<ng-container *ngIf="appState$ | async; let app_state">
  <router-outlet></router-outlet>
</ng-container>